import {h, Fragment} from "preact"
import { useAppState, useProductFilters } from '@nosto/preact'
import { isFrench } from '../config'

import Facet from './Facet'
import RangeFacet from './RangeFacet'
import SubscribeFacet from './SubscribeFacet'

export default ({ sidebarActive, toggleSidebar, isFrench }) => {
    const { response: { products } = {} } = useAppState();
    const { filters, removeAll } = useProductFilters();
    const docCount = products?.total ?? 0;

    return products?.facets?.length > 0 ? (
        <div class={`ns-sidebar-wrapper ${sidebarActive ? 'active' : ''}`}
            style={{
                    transition: 'all 0.3s',
                    transform: sidebarActive 
                        ? 'translateX(0)' 
                        : window.innerWidth < 1024 
                            ? 'translateX(200%)'
                            : 'translateX(-100%)'
            }}
        >
            <div class="ns-sidebar-content relative flex flex-col">
                <div class="ns-sidebar-header flex">
                    <span class="ns-sidebar-title">{isFrench ? 'Filtres' : 'Filters'}</span>
                    <div class="ns-sidebar-header-controls flex align-center">
                        {filters.length > 0 && 
                            <button type="button"
                                class="ns-sidebar-clearall"
                                onClick={removeAll} >
                                    {isFrench ? 'Tout effacer' : 'Clear All'}
                            </button>
                        }
                        <button type="button"
                            class="ns-close-sidebar"
                            onClick={toggleSidebar} >
                            <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m2 2 15.556 15.556M2 18 17.556 2.444" stroke="#000" stroke-width="1.5"></path></svg>
                        </button>
                    </div>
                </div>
                <div class="ns-sidebar-menu">
                    <ul class="ns-list-unstyled">
                        {products?.facets?.map((facet) => {
                            if (facet.field === "customFields.filters-filter_subscription") {
                                return <SubscribeFacet facet={facet} />
                            } else if (facet.type === 'terms') {
                                return <Facet facet={facet} />
                            } else if (facet.type === "stats") {
                                return <RangeFacet facet={facet} />
                            } else {
                                return null
                            }
                        })}
                    </ul>
                </div>
                <div class="ns-sidebar-bot-toolbar flex">
                    <div class="ns-sidebar-results">{docCount} {isFrench ? "Produits" : "Items"}</div>
                    <button type="submit" class="ns-sidebar-apply-btn"  onClick={toggleSidebar}>{isFrench ? 'Appliquer' : 'Apply'}</button>
                </div>
            </div>
        </div>
    ) : ( null )
}